import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function FinalCta() {
  return <section className="py-24 bg-iris-black relative overflow-hidden border-t border-iris-border" data-id="element-55">
      <div className="absolute inset-0 bg-topo-pattern opacity-30 pointer-events-none" data-id="element-56"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-full bg-iris-green/5 blur-[100px] pointer-events-none" data-id="element-57"></div>

      <Container className="relative z-10 text-center" data-id="element-58">
        <h2 className="text-4xl md:text-6xl font-display font-bold text-white mb-6 max-w-4xl mx-auto leading-tight" data-id="element-59">
          REPLACE THE SPREADSHEET STACK. OPERATIONALIZE YOUR WORKFLOW.
        </h2>
        <p className="text-lg text-iris-muted mb-10 max-w-2xl mx-auto" data-id="element-60">
          Join the agencies already using IRIS to secure their requests, track
          performance, and reclaim hours across their teams.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-61">
          <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-62">
            Schedule a Walkthrough
          </Button>
          <Button variant="secondary" size="lg" data-id="element-63">
            Download Capability Brief
          </Button>
        </div>
      </Container>
    </section>;
}